import React from 'react';
import { SOURCE_LABELS } from '../alertSources';

// User Notice at the foot of each agency alert page (10-28, item 11). Copy
// as supplied by Cary 10-28, with the agency name filled in per page; only
// obvious slips were corrected ("authorized" + "NuVola AI" joined into one
// sentence, "offered", "cybercriminals").
const AgencyNotice = ({ source }) => {
  const agency = SOURCE_LABELS[source] || source;
  return (
    <aside
      aria-label="User notice"
      className="mt-12 border-t border-gray-300 pt-6 text-sm leading-relaxed text-gray-600"
    >
      <p className="font-semibold text-black">User Notice</p>
      <p className="mt-2">
        The {agency} is not affiliated with or endorses NuVola AI &ndash; No / SCAM application.
        Videos are used in accordance with Fair Use provisions, section 107 of the U.S. Copyright
        law. All videos were developed and are the property of {agency} and no specific permission
        has been authorized to NuVola AI. These videos are offered to promote a greater understanding
        of the pervasive, devastating impact that cybercriminals have on the American public and to
        promote greater scammer prevention awareness.
      </p>
    </aside>
  );
};

export default AgencyNotice;
